import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import printFilters from './mixins/printFilters'
// import dynamicData from './mixins/dynamicData'

import VTooltip from 'v-tooltip'
import { VClosePopover } from 'v-tooltip'
import AsyncComputed from 'vue-async-computed'
import VModal from 'vue-js-modal'

import InfoNoteTooltip from '@/components/commons/InfoNoteTooltip'
import LoadingOverlay from '@/components/commons/LoadingOverlay'
import ErrorOverlay from '@/components/commons/ErrorOverlay'
import VueI18n from 'vue-i18n'
import en from '@/i18n/lang/en'
import es from '@/i18n/lang/es'

import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations as TracingIntegrations } from "@sentry/tracing";
import Hotjar from 'vue-hotjar'

import vClickOutside from 'v-click-outside'
import { getEnvVar } from '@/utils/envUtils'

Vue.use(AsyncComputed)

Vue.config.productionTip = false

Vue.use(VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.use(VModal, { dialog: true })
Vue.use(VueI18n)
Vue.mixin(printFilters)
Vue.use(vClickOutside)
// Vue.mixin(dynamicData)

Vue.component('info-note-tooltip', InfoNoteTooltip)
Vue.component('loading-overlay', LoadingOverlay)
Vue.component('error-overlay', ErrorOverlay)

let messages = { en, es }
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'en', // set locale
  messages, // set locale messages
})

if (getEnvVar('NODE_ENV') === 'production') {
  Sentry.init({
    environment: getEnvVar('VUE_APP_SENTRY_ENV'),
    dsn: getEnvVar('VUE_APP_SENTRY_KEY'),
    integrations: [new VueIntegration(
      {Vue, attachProps: true, tracing: true, tracingOptions: { trackComponents: true}}),
    new TracingIntegrations.BrowserTracing()],
  })
  Vue.use(Hotjar, {
    id: getEnvVar('VUE_APP_HOTJAR_ID'), // Hotjar Site ID
  })
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
